<template>
  <div>
    <div class="logo_wrap">
      <div class="logo_block">
        <!-- 2023/10/25: 添加 logo 点击事件,点击返回首页 -->
        <img
          class="logo_img"
          src="../assets/images/public/logo.png"
          alt=""
          @click="handleLogoClick"
        />
        <ul class="nav_wrap">
          <!-- tab nav 列表 -->
          <li
            v-for="item in navList"
            :key="item.id"
            @click="changeType(item.id)"
            @mouseenter="onMouseOver(item.id, item.name)"
          >
            <span :class="[indexId == item.id ? 'chageTap' : '']">
              {{ item.name }}
            </span>
            <div class="son_wrap" v-if="isDownShow">
              <div class="down_wrap">
                <div class="down_title">{{ downName }}</div>
                <ul class="down_list">
                  <li
                    class="down_list_item"
                    v-for="(item1, index1) in sonList"
                    :key="index1"
                    @click.stop="goList(index1,item1.id)"
                  >
                    <div class="list_content">
                      <span>{{ item1[`${currentLang.prefix}cate_name`] }}</span>
                      <i class="el-icon-arrow-down"></i>
                    </div>
                    <ul class="cate_list">
                      <li
                        v-for="(item2, index2) in item1.cate_list"
                        :key="index2"
                        @click.stop="goList(index1,item1.id,item2.id)"
                      >
                        {{ item2[`${currentLang.prefix}cate_name`] }}
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <div class="sign_wrap">
            <img src="../assets/images/public/60.png" alt="" />
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getCateListProduct } from "@/utils/http.js";
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      indexId: "",
      list: [
        {
          id: 1,
          name: "产品中心"
        },
        {
          id: 2,
          name: "产品方案"
        },
        {
          id: 3,
          name: "客户服务"
        },
        {
          id: 4,
          name: "联系我们"
        }
      ],
      downName: "",
      sonList: [],
      isDownShow: false
    };
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    navList() {
      const subNavbar = this.currentLang.config.subNavbar
      return [
        {
          id: 1,
          name: subNavbar.productCenter
        },
        {
          id: 2,
          name: subNavbar.productProgram
        },
        {
          id: 3,
          name: subNavbar.customerService
        },
        {
          id: 4,
          name: subNavbar.contactUs
        }
      ]
    }
  },

  mounted() {
    if (this.$route.path === "/prod_center" || this.$route.path === "/prod_list") {
      this.indexId = 1;
    }
    if (
      this.$route.path === "/cpProgram" ||
      this.$route.path === "/programDetail"
    ) {
      this.indexId = 2;
    }
    if (this.$route.path === "/customer_service") {
      this.indexId = 3;
    }
    if (this.$route.path === "/callMe") {
      this.indexId = 4;
    }
  },
  watch: {

'$route'(to,from) {

    this.$router.go(0);

}

},
  methods: {
    changeType(id) {
      this.indexId = id;

      switch (this.indexId) {
        case 1:
          this.$router.push("/prod_center");
          break;
        case 2:
          this.$router.push("/cpProgram");
          break;
        case 3:
          this.$router.push("/customer_service");
          break;
        case 4:
          this.$router.push("/callMe");
          break;
        default:
          break;
      }
    },

    // 左侧 logo 点击回调
    handleLogoClick() {
      this.$router.push("/");
    },
    onMouseOver(id, name) {
      switch (id) {
        case 1:
          this.downName = name;
          this.isDownShow = true;
          getCateListProduct().then(res => {
            console.log(res);
            if (res.code === 1) {
              this.sonList = res.data;
            }
          });
          break;
        default:
          this.isDownShow = false;
          break;
      }
    },
    goList(index,id,sonId){
      console.log(index,id,sonId)
      this.$router.push({ path: "/prod_list", query: {index:index,parentId:id,sonId: sonId} })
    }
  }
};
</script>
<style lang="scss" scoped>
.logo_wrap {
  width: 100%;
  height: 110px;
  background: #fff;

  .logo_block {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .logo_img {
      width: 136px;
      height: 57px;
      margin-top: 32px;
    }

    .nav_wrap {
      display: flex;
      li {
        margin-right: 48px;
        font-size: 20px;
        margin-top: 59px;
        span {
          color: #333;
        }
        .son_wrap {
          width: 100%;
          padding: 50px 0;
          background: #003359;
         
          position: absolute;
          top: 150px;
          z-index: 3;
          left: 0;
          display: none;
          .down_wrap {
            width: 1200px;
            margin: 0 auto;
            .down_title {
              font-size: 18px;
              color: #fff;
              padding-bottom: 20px;
              border-bottom: 2px solid #244f70;
            }
            .down_list {
              display: flex;
              justify-content: space-between;
              flex-wrap: wrap;
              .down_list_item {
                width: calc(100% / 4 - 40px);
                margin-right: 0;

                margin-top: 15px;
                .list_content {
                  padding-bottom: 15px;
                  border-bottom: 2px solid #244f70;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  span {
                    font-size: 16px;
                    color: #fff;
                  }
                  i {
                    color: #fff;
                  }
                }
                .cate_list {
                  display: none;
                  li {
                    margin-right: 0;
                    margin-top: 15px;
                    font-size: 14px;
                    color: #fff;
                  }
                }
              }
              .down_list_item:hover {
                .cate_list {
                  display: block;
                }
              }
            }
          }
        }
      }
      li:hover {
        cursor: pointer;
        .son_wrap {
          display: block;
        }
      }

      .sign_wrap {
        width: 100px;
        height: 101px;
        position: relative;

        img {
          width: 100px;
          height: auto;
          position: absolute;
          top: 21px;
          z-index: 3;
        }
      }
    }
  }
}
.chageTap {
  color: #0f335e !important;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/secordHeader.vue